module.exports = __webpack_public_path__ + "AvertaStd-Regular.svg?70bdda51c0a35a214f6e5c5eaeaa432a";